module.exports = __webpack_public_path__ + "static/media/entree-tv.24389d5d.svg";